import { MutableRefObject, useEffect, useRef, useState } from 'react';

interface Bounds {
  left: number;
  top: number;
  bottom: number;
  right: number;
  width: number;
  height: number;
}
export function useMeasure(callback?: (bounds: Bounds) => void) {
  const ref = useRef();
  const [bounds, set] = useState<Bounds>({ left: 0, top: 0, bottom: 0, right: 0, width: 0, height: 0 });
  const [resizeObserver] = useState(
    () =>
      new ResizeObserver(([entry]) => {
        if (entry) {
          set(entry.contentRect);
          callback?.(entry.contentRect);
        }
      })
  );
  useEffect(() => {
    if (ref.current) resizeObserver.observe(ref.current);
    return () => resizeObserver.disconnect();
  }, [resizeObserver]);

  return [{ ref }, bounds] as [{ ref: MutableRefObject<any> }, Bounds];
}
